module.exports = __webpack_public_path__ + "static/media/e64c8b5fab4b436f8297e4b8962f1900.eb8b0161.jpg";